import { FC, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Formik, useFormik } from "formik";
import { DateTime } from "luxon";
import { t } from "i18next";

import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import TableListMatricula from "@/shared/components/organisms/TableListMatricula";
import { InputDropDownSpan } from "@/shared/components/atoms/InputDropDownSpan";
import AlertErrorButtons from "@/shared/components/molecules/AlertErrorButtons";
import { FeeTableList } from "@/shared/components/organisms/TableListCoutas";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { ModalWithTabs } from "@/shared/components/organisms/ModalTabs";
import PaginationUI from "@/shared/components/atoms/PaginationUI";
import { ModalXXL } from "@/shared/components/organisms/ModalXXL";
import { Select } from "@/shared/components/organisms/Select";
import { Modal } from "@/shared/components/organisms/Modal";

import { useDebounce } from "@/shared/hooks/debounce";
import { toasts } from "@/shared/utils/toasts";

import {
  useFeesMutation,
  useKpiFeesQuery,
  useCreateFeeMutation,
  useUpdateFeeMutation,
  useInfluencerQuery,
  useDisableFeeBranchMutation,
} from "@/app/fees/fees.api";
import { useInstallationsQuery } from "@/app/installations/installations.api";

import {
  Fee,
  periods,
  currencies,
  daysOfWeek,
  getFormatedPeriod,
} from "@/app/fees/fees";

import { useBranchsGymQuery } from "@/app/branchs/branchs.api";

import { configureExporting } from "@/shared/utils/chartUtils";

import {
  useCreateReasonMutation,
  useReasonsQuery,
} from "@/app/reasons/reasons.api";

import {
  FeeValues,
  feeInitialValues,
  feeValidationSchema,
  disabledFeeInitialValues,
  disabledFeeValidationSchema,
} from "@/shared/schemas/fees.schema";

import {
  CreateReasonValues,
  createReasonInitialValue,
  createReasonValidationSchema,
} from "@/shared/schemas/reasons.schema";
import { reasonTypes } from "@/app/reasons/reasons";

import {
  createRegistrationPaymentInitialValues,
  createRegistrationPaymentValidationSchema,
} from "@/shared/schemas/registration-payments.schema";

import { RegistrationPayment } from "@/app/registration-payments/registration-payments";

import {
  useRegistrationPaymentsQuery,
  useCreateRegistrationPaymentMutation,
  useUpdateRegistrationPaymentMutation,
} from "@/app/registration-payments/registration-payments.api";
import { Permission, usePermission } from "@/shared/hooks/usePermission";

const tabs = [
  { id: 1, name: t("general.reasons") },
  { id: 2, name: t("general.kpi") },
];

export const FeesPage: FC<any> = () => {
  const { id } = useParams();

  const [currentFee, setCurrentFee] = useState<Fee | undefined>();
  const [search, setSearch] = useState<string | undefined>();
  const [openAlertEdit, setOpenAlertEdit] = useState(false);
  const [feeEdit, setFeeEdit] = useState<Fee | undefined>();
  const [open, setOpen] = useState(false);
  const openDialog = () => {
    setOpen(!open);
  };
  const { can } = usePermission();

  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [optionsBranchs, setOptionsBranchs] = useState<any[]>([]);

  const [initialValues, setInitialValues] = useState(disabledFeeInitialValues);

  const [currentRegistrationPaymentEdit, setCurrentRegistrationPaymentEdit] =
    useState<RegistrationPayment | undefined>();

  const agreementsFormik = useFormik({
    initialValues: {
      startDate: DateTime.now().minus({ weeks: 1 }).toFormat("yyyy-MM-dd"),
      endDate: DateTime.now().toFormat("yyyy-MM-dd"),
    },
    onSubmit: () => {},
  });

  const [createFee, createFeeResult] = useCreateFeeMutation();
  const [updateFee, updateFeeResult] = useUpdateFeeMutation();
  const [disableFeeBranch] = useDisableFeeBranchMutation();
  const [createReason, createReasonResult] = useCreateReasonMutation();

  const debouncedSearch = useDebounce(search, 200);

  const [createRegistrationPayment, createRegistrationPaymentResult] =
    useCreateRegistrationPaymentMutation();
  const [updateRegistrationPayment, updateRegistrationPaymentResult] =
    useUpdateRegistrationPaymentMutation();

  const [tokenInfluencer, setTokenInfluencer] = useState(null);
  const influencerQuery = useInfluencerQuery({ branchId: id });

  useEffect(() => {
    if (influencerQuery.isSuccess) {
      setTokenInfluencer(
        influencerQuery.data != null ? influencerQuery.data.token : undefined
      );
    }
  }, [influencerQuery]);

  const reasonsQuery = useReasonsQuery({ branchId: id });
  const branchsQuery = useBranchsGymQuery({ branchId: id });
  const installationsQuery = useInstallationsQuery({ branchId: id });

  const registrationPaymentsQuery = useRegistrationPaymentsQuery({
    branchId: id,
  });
  const [getterFees, getterFeesResult] = useFeesMutation();

  useEffect(() => {
    getterFees({
      branchId: id,
      search: debouncedSearch,
      page: debouncedSearch ? 1 : page,
    });
  }, [id, debouncedSearch, page]);

  useEffect(() => {
    if (currentFee) {
      setOpen(true);
    }
  }, [currentFee]);

  useEffect(() => {
    if (branchsQuery?.data) {
      setOptionsBranchs(
        branchsQuery.data.map((reason, index) => ({
          id: reason.id,
          name: reason.branch,
        }))
      );
    }
  }, [branchsQuery]);

  useEffect(() => {
    if (currentRegistrationPaymentEdit) {
      setOpenModalCreateMatriculasState(true);
    }
  }, [currentRegistrationPaymentEdit]);

  //CHECKED MULTICENTRO
  const [multicentro, setMulticentro] = useState(false);
  //OPEN FOR MODAL MATRICULAS
  const [openModal, setOpenModal] = useState(false);
  const openModalMatriculas = () => {
    setOpenModal(!openModal);
  };
  //OPEN MODAL PAUSE
  const [openModalPause, setOpenModalPause] = useState(false);
  const openModalPauseState = () => {
    setOpenModalPause(!openModalPause);
  };
  //OPEN MODAL MOTIVOS
  const [openModalMotivos, setOpenModalMotivos] = useState(false);
  const openModalMotivosState = () => {
    setOpenModalMotivos(!openModalMotivos);
  };
  //OPEN MODAL CREATE MATRICULAS
  const [openModalCreateMatriculasState, setOpenModalCreateMatriculasState] =
    useState(false);
  const openModalCreateMatriculas = () => {
    setOpenModalCreateMatriculasState(!openModalCreateMatriculasState);
  };
  //STATE FOR CONTROL OF TABS
  const [selectedTab, setSelectedTab] = useState(1);
  //STATE MODAL CREATE MOTIVOS
  const [openModalCreateMotivosState, setOpenModalCreateMotivosState] =
    useState(false);
  const openModalCreateMotivos = () => {
    setOpenModalCreateMotivosState(!openModalCreateMotivosState);
  };
  //SELECT MULTICENTRO
  const [centro, setCentro] = useState([]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const copyValueFromArray = (fee: Fee) => {
    if (!tokenInfluencer) {
      toasts.info("Link no copiado", "No hemos encontrado un token.");
      return;
    }

    const link = `${window.location.origin}/register/user?token=${tokenInfluencer}&fee=${fee.id}&branch=${id}`;

    navigator.clipboard
      .writeText(link)
      .then(() => {
        toasts.success("Link", "¡Link copiado!");
      })
      .catch((err) => {
        console.error("Error al copiar al portapapeles: ", err);
      });
  };

  const { data: getKpiFeesBranch } = useKpiFeesQuery({
    branchId: id,
    from_date: agreementsFormik.values.startDate,
    to_date: agreementsFormik.values.endDate,
  });

  const createReasonsHigh = (
    data: { reasonGrap1: number[]; reasonLabel1: string[] },
    totalSum: number
  ): am5.Root => {
    const root = am5.Root.new("reason_high");

    root.setThemes([am5themes_Animated.new(root)]);
    if (root._logo) {
      root._logo.dispose();
    }

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(50),
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        alignLabels: false,
      })
    );

    series.children.push(
      am5.Label.new(root, {
        centerX: am5.percent(50),
        centerY: am5.percent(50),
        text: "Total: " + totalSum,
        populateText: true,
        fontSize: "1.2em",
      })
    );

    series.labels.template.setAll({
      forceHidden: true,
    });

    series.slices.template.set(
      "tooltipText",
      "{category} - Total: [bold]{value}[/]"
    );

    // Transformar los datos
    const transformedData = data.reasonGrap1.map((value, index) => ({
      category: data.reasonLabel1[index],
      value: value,
    }));

    series.data.setAll(transformedData);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 15,
        marginBottom: 15,
      })
    );

    // Configurar las etiquetas de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.labels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    // Configurar los valores de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.valueLabels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    legend.data.setAll(series.dataItems);

    series.appear(1000, 100);

    return root;
  };

  const createReasonsLow = (
    data: { reasonGrap2: number[]; reasonLabel2: string[] },
    totalSum: number
  ): am5.Root => {
    const root = am5.Root.new("reasons_low");

    root.setThemes([am5themes_Animated.new(root)]);
    if (root._logo) {
      root._logo.dispose();
    }

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(50),
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        alignLabels: false,
      })
    );

    series.children.push(
      am5.Label.new(root, {
        centerX: am5.percent(50),
        centerY: am5.percent(50),
        text: "Total: " + totalSum,
        populateText: true,
        fontSize: "1.2em",
      })
    );

    series.labels.template.setAll({
      forceHidden: true,
    });

    series.slices.template.set(
      "tooltipText",
      "{category} - Total: [bold]{value}[/]"
    );

    // Transformar los datos
    const transformedData = data.reasonGrap2.map((value, index) => ({
      category: data.reasonLabel2[index],
      value: value,
    }));

    series.data.setAll(transformedData);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 15,
        marginBottom: 15,
      })
    );

    // Configurar las etiquetas de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.labels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    // Configurar los valores de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.valueLabels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    legend.data.setAll(series.dataItems);

    series.appear(1000, 100);

    setIsLoading(false);

    configureExporting(root, transformedData);

    return root;
  };

  useEffect(() => {
    if (getKpiFeesBranch && openModalMotivos && selectedTab === 2) {
      const chart1 = createReasonsHigh(
        getKpiFeesBranch,
        getKpiFeesBranch.reasonGrap1.reduce((a, b) => a + b, 0)
      );
      const chart2 = createReasonsLow(
        getKpiFeesBranch,
        getKpiFeesBranch.reasonGrap2.reduce((a, b) => a + b, 0)
      );
      return () => {
        chart1.dispose();
        chart2.dispose();
      };
    }
  }, [getKpiFeesBranch, openModalMotivos, selectedTab]);

  const handleClose = () => {
    setCurrentFee(undefined);
  };

  return (
    <div className="flex flex-col flex-1 overflow-y-scroll w-full pt-5">
      <div className="flex flex-1 flex-col w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto">
        <FeeTableList
          isLoading={getterFeesResult.isLoading}
          onSearchChange={(event) => setSearch(event.target.value)}
          onEditFee={(fee) => {
            setOpenAlertEdit(!openAlertEdit);
            setFeeEdit(fee);
          }}
          search={search}
          title={t("customer-to-gym-subscription.views.title")}
          description={t("customer-to-gym-subscription.views.subtittle")}
          fees={getterFeesResult.data ?? []}
          functionButtonCreate={() => {
            setCurrentFee(undefined);
            openDialog();
          }}
          canCreateFee={can(Permission.BRANCH_ACCESS_CREATE_FEE)}
          canEditFee={can(Permission.BRANCH_ACCESS_EDIT_FEE)}
          canPauseFee={can(Permission.BRANCH_ACCESS_STOP_FEE)}
          functionButtonMatriculas={openModalMatriculas}
          functionButtonPause={(fee) => {
            openModalPauseState();
            setInitialValues({
              ...disabledFeeInitialValues,
              fee_id: fee.id,
            });
          }}
          functionButtonLink={(fee) => copyValueFromArray(fee)}
          functionButtonMotivos={openModalMotivosState}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          currentPage={page}
        />
        {getterFeesResult.data && (
          <PaginationUI
            onPageChange={(event) => handlePageChange(event)}
            currentPage={page}
            pageSize={10}
            totalResults={getterFeesResult.data.length}
            totalPages={Math.ceil(
              (getterFeesResult?.data.length ?? 0) / pageSize
            )}
          />
        )}

        <AlertErrorButtons
          open={openAlertEdit}
          onClose={() => setOpenAlertEdit(!openAlertEdit)}
          title={t("customer-to-gym-subscription.views.title")}
          message={t("customer-to-gym-subscription.views.edit_message")}
          primaryButtonText={t("general.edit")}
          secondaryButtonText={t("general.cancel")}
          onPrimaryButtonClick={() => {
            setCurrentFee({
              ...feeEdit,
              price: feeEdit.price / 100,
              registrationPaymentId: feeEdit.registrationPaymentId ?? 0,
              days: feeEdit.feeSchedules
                .map((schedule) => schedule.day.split(", "))
                .flat(),
            });
            setOpenAlertEdit(!openAlertEdit);
          }}
          onSecondaryButtonClick={() => {
            setOpenAlertEdit(!openAlertEdit);
          }}
        />

        {/*DIALOG CREATE COUTAS*/}
        <Formik
          enableReinitialize
          validationSchema={feeValidationSchema}
          initialValues={currentFee ?? feeInitialValues}
          onSubmit={async (values, formikHelpers) => {
            try {
              if (currentFee) {
                await updateFee({
                  ...values,
                  amount: values.price,
                  branchId: id,
                  id: currentFee.id,
                }).unwrap();
                getterFees({ branchId: id, search: debouncedSearch });
                toasts.success(
                  "Actualización exitosa",
                  "La cuota se ha actualizado correctamente"
                );
              } else {
                await createFee({
                  ...values,
                  branchId: id,
                }).unwrap();
                getterFees({ branchId: id, search: debouncedSearch });
                toasts.success(
                  "Registro exitoso",
                  "La cuota se ha creado correctamente"
                );
              }
              formikHelpers.resetForm();
              setCurrentFee(undefined);
              setOpen(false);
            } catch (error) {
              if (currentFee) {
                toasts.danger(
                  "Error al actualizar la cuota",
                  "Ha ocurrido un error al actualizar la cuota"
                );
                return;
              }
              toasts.danger(
                "Error al crear la cuota",
                "Ha ocurrido un error al crear la cuota"
              );
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            values,
            handleSubmit,
            errors,
            isValid,
            resetForm,
            touched,
          }) => {
            return (
              <DialogCreate
                open={open}
                setOpen={setOpen}
                tittle={
                  currentFee
                    ? t("customer-to-gym-subscription.views.edit_fee")
                    : t("customer-to-gym-subscription.views.create_fee")
                }
                subTittle={t("customer-to-gym-subscription.views.creation_fee")}
                tittleButtonCreate={
                  currentFee ? t("general.edit") : t("general.create")
                }
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                OnclickCancel={() => {
                  setOpen(false);
                  resetForm();
                }}
                isLoading={
                  createFeeResult.isLoading || updateFeeResult.isLoading
                }
                acceptDisabled={
                  createFeeResult.isLoading ||
                  updateFeeResult.isLoading ||
                  !isValid
                }
                cancelDisabled={
                  createFeeResult.isLoading || updateFeeResult.isLoading
                }
                onClose={handleClose}
              >
                <form action="">
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t(
                                "customer-to-gym-subscription.views.principal_caracteristics"
                              )}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t(
                                "customer-to-gym-subscription.views.name"
                              )}
                              span={t("general.mandatory")}
                              name="name"
                              type="text"
                              placeholder={t(
                                "customer-to-gym-subscription.views.name"
                              )}
                              onChange={handleChange}
                              error={touched.name && !!errors.name}
                              textError={touched.name && errors.name}
                              value={values.name}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t(
                                "customer-to-gym-subscription.views.description"
                              )}
                              span={t("general.mandatory")}
                              name="description"
                              error={
                                touched.description && !!errors.description
                              }
                              textError={
                                touched.description && errors.description
                              }
                              onChange={handleChange}
                              value={values.description}
                              type="text"
                              placeholder={t(
                                "customer-to-gym-subscription.views.description"
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("customer-to-gym-subscription.views.price")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <Select
                              name="registrationPaymentId"
                              span={t("general.optional")}
                              selected={registrationPaymentsQuery?.data?.find(
                                (registrationPayment: RegistrationPayment) =>
                                  registrationPayment?.id ==
                                  values.registrationPaymentId
                              )}
                              setSelected={(option) =>
                                setFieldValue(
                                  "registrationPaymentId",
                                  option.id
                                )
                              }
                              options={registrationPaymentsQuery?.data}
                              tittle={t(
                                "customer-to-gym-subscription.views.registration"
                              )}
                              error={
                                touched.registrationPaymentId &&
                                !!errors.registrationPaymentId
                              }
                              textError={
                                touched.registrationPaymentId &&
                                errors.registrationPaymentId
                              }
                            />
                          </div>

                          <div className="col-span-full">
                            <InputDropDownSpan
                              label={t(
                                "customer-to-gym-subscription.views.mount"
                              )}
                              span={t("general.mandatory")}
                              name="price"
                              type="number"
                              placeholder={t(
                                "customer-to-gym-subscription.views.mount"
                              )}
                              onChange={(e) => {
                                const value = parseFloat(e.target.value);
                                handleChange({
                                  target: {
                                    name: e.target.name,
                                    value: isNaN(value) ? "" : value,
                                  },
                                });
                              }}
                              value={values.price}
                              nameSelect="currency"
                              selectValue={values.currency.toUpperCase()}
                              onSelectChange={handleChange}
                              options={currencies.map((item) => ({
                                ...item,
                                id: item.currency,
                                text: item.currency,
                              }))}
                              error={
                                (touched.price && !!errors.price) ||
                                (touched.currency && !!errors.currency)
                              }
                              textError={
                                (touched.price && errors.price) ||
                                (touched.currency && errors.currency)
                              }
                            />
                          </div>

                          <div className="col-span-full">
                            <Select
                              name="period"
                              span={t("general.optional")}
                              selected={
                                currentFee
                                  ? periods.find(
                                      (option) =>
                                        option.name ===
                                        getFormatedPeriod(
                                          values.interval,
                                          values.intervalCount
                                        )
                                    )
                                  : periods.find(
                                      (option) =>
                                        option.period === values.period
                                    )
                              }
                              setSelected={(option) => {
                                setFieldValue("period", option.period);
                              }}
                              options={periods}
                              tittle={t(
                                "customer-to-gym-subscription.views.renewal_period"
                              )}
                              error={touched.period && !!errors.period}
                              textError={touched.period && errors.period}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              span={t("general.optional")}
                              label={t(
                                "customer-to-gym-subscription.views.periot_free"
                              )}
                              name="trialPeriodDays"
                              type="number"
                              placeholder={t(
                                "customer-to-gym-subscription.views.periot_free"
                              )}
                              onChange={handleChange}
                              error={
                                touched.trialPeriodDays &&
                                !!errors.trialPeriodDays
                              }
                              textError={
                                touched.trialPeriodDays &&
                                errors.trialPeriodDays
                              }
                              value={values.trialPeriodDays}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t(
                                "customer-to-gym-subscription.views.number_of_people"
                              )}
                              span={t("general.optional")}
                              name="people"
                              type="number"
                              placeholder={t(
                                "customer-to-gym-subscription.views.number_of_people"
                              )}
                              onChange={handleChange}
                              error={touched.people && !!errors.people}
                              textError={touched.people && errors.people}
                              value={values.people}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t(
                                "customer-to-gym-subscription.views.discount_text"
                              )}
                              span={t("general.optional")}
                              name="discount"
                              type="number"
                              placeholder={t(
                                "customer-to-gym-subscription.views.discount_text"
                              ).slice(0, 11)}
                              value={values.discount}
                              onChange={handleChange}
                              error={touched.discount && !!errors.discount}
                              textError={touched.discount && errors.discount}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t(
                                "customer-to-gym-subscription.views.discount_period"
                              )}
                              span={t("general.optional")}
                              name="repeatDiscount"
                              type="number"
                              placeholder={t(
                                "customer-to-gym-subscription.views.discount_period"
                              )}
                              onChange={handleChange}
                              error={
                                touched.repeatDiscount &&
                                !!errors.repeatDiscount
                              }
                              textError={
                                touched.repeatDiscount && errors.repeatDiscount
                              }
                              value={values.repeatDiscount}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("customer-to-gym-subscription.views.access")}{" "}
                              here
                            </h2>
                            <p className="mt-1 text-sm leading-6 text-gray-600"></p>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <div className="mt-4 grid grid-cols-3 gap-4 items-center">
                              <div className="block text-sm font-medium leading-6 text-gray-600 text-center">
                                {t("customer-to-gym-subscription.views.days")}
                              </div>
                              <div className="block text-sm font-medium leading-6 text-gray-600 text-center">
                                {t(
                                  "customer-to-gym-subscription.views.time_init"
                                )}
                              </div>
                              <div className="block text-sm font-medium leading-6 text-gray-600 text-center">
                                {t(
                                  "customer-to-gym-subscription.views.time_end"
                                )}
                              </div>
                            </div>
                            {daysOfWeek.map((day, index) => (
                              <div
                                key={day.name}
                                className="grid grid-cols-3 sm:gap-4 items-center mt-4"
                              >
                                <div className="flex justify-center items-center bgg">
                                  <label
                                    key={day.name}
                                    className="cursor-pointer"
                                  >
                                    <input
                                      type="checkbox"
                                      className="hidden peer"
                                      name={`days[${index}]`}
                                      onChange={(event) => {
                                        const newDays = event.target.checked
                                          ? [
                                              ...(Array.isArray(values.days)
                                                ? values.days
                                                : []),
                                              day.name,
                                            ]
                                          : (Array.isArray(values.days)
                                              ? values.days
                                              : []
                                            ).filter(
                                              (_day) => _day !== day.name
                                            );
                                        setFieldValue("days", newDays);
                                      }}
                                      checked={
                                        Array.isArray(values.days) &&
                                        values.days.includes(day.name)
                                      }
                                    />
                                    <span className=" sm:w-16 h-12 flex items-center justify-center px-4 py-2 border rounded-full text-lg text-gray-500 border-gray-300 peer-checked:bg-primary peer-checked:border-primary peer-checked:text-white transition-colors duration-300 ease-in-out">
                                      {day.text}
                                    </span>
                                  </label>
                                </div>
                                <div className="flex justify-center">
                                  <InputWithCornerHint
                                    label=""
                                    disabled={
                                      !Array.isArray(values.days) ||
                                      !values.days.includes(day.name)
                                    }
                                    onChange={handleChange}
                                    name={`hourInit.${day.name}`}
                                    type="time"
                                    placeholder=""
                                    value={values.hourInit[day.name]}
                                    error={false}
                                  />
                                </div>
                                <div className="flex justify-center">
                                  <InputWithCornerHint
                                    label=""
                                    disabled={
                                      !Array.isArray(values.days) ||
                                      !values.days.includes(day.name)
                                    }
                                    onChange={handleChange}
                                    name={`hourFinish.${day.name}`}
                                    type="time"
                                    placeholder=""
                                    value={values.hourFinish[day.name]}
                                    error={false}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="col-span-full">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.automatedTraining}
                                  onChange={(event) => {
                                    setFieldValue(
                                      "automatedTraining",
                                      event.target.checked
                                    );
                                  }}
                                  name="automatedTraining"
                                  type="checkbox"
                                  aria-describedby=""
                                  className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor=""
                                  className="font-medium text-gray-900"
                                >
                                  {t(
                                    "customer-to-gym-subscription.views.access_plans"
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-span-full">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.automatedNutrition}
                                  onChange={(event) => {
                                    setFieldValue(
                                      "automatedNutrition",
                                      event.target.checked
                                    );
                                  }}
                                  name="automatedNutrition"
                                  type="checkbox"
                                  className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor=""
                                  className="font-medium text-gray-900"
                                >
                                  {t(
                                    "customer-to-gym-subscription.views.access_plans_nutrition"
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-span-full">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.app}
                                  onChange={(event) => {
                                    setFieldValue("app", event.target.checked);
                                  }}
                                  name="app"
                                  type="checkbox"
                                  aria-describedby=""
                                  className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor=""
                                  className="font-medium text-gray-900"
                                >
                                  {t(
                                    "customer-to-gym-subscription.views.visible_app"
                                  )}{" "}
                                  app
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-span-full">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.centerAccess}
                                  onChange={(event) => {
                                    setFieldValue(
                                      "centerAccess",
                                      event.target.checked
                                    );
                                    setMulticentro(!multicentro);
                                  }}
                                  id="centerAccess"
                                  name="centerAccess"
                                  type="checkbox"
                                  aria-describedby=""
                                  className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor=""
                                  className="font-medium text-gray-900"
                                >
                                  {t(
                                    "customer-to-gym-subscription.views.access_multicenter"
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                          {multicentro ? (
                            <>
                              <div className="col-span-full">
                                <MultiSelect
                                  span={t("general.optional")}
                                  options={optionsBranchs}
                                  selectedOptions={centro}
                                  setSelectedOptions={setCentro}
                                  title={t(
                                    "customer-to-gym-subscription.views.centers"
                                  )}
                                />
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          <div className="col-span-full">
                            <MultiSelect
                              title={t(
                                "customer-to-gym-subscription.views.instalations"
                              )}
                              span={t("general.optional")}
                              selectedOptions={installationsQuery?.data?.filter(
                                (fee) => values.installations.includes(fee.id)
                              )}
                              setSelectedOptions={(selected) =>
                                setFieldValue(
                                  "installations",
                                  selected.map((fee) => fee.id).join(",")
                                )
                              }
                              options={installationsQuery?.data ?? []}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>

        {/* Modal matriculas table*/}
        <ModalXXL
          open={openModal}
          Close={openModalMatriculas}
          tittleModal={t("customer-to-gym-subscription.views.registrations")}
          textButtonClose={t("general.close")}
          textButtonTopCreate={t(
            "customer-to-gym-subscription.views.create_registration"
          )}
          functionButtonTopCreate={openModalCreateMatriculas}
          modalClassName="z-50"
        >
          <TableListMatricula
            onEdit={(registrationPayment) =>
              setCurrentRegistrationPaymentEdit(registrationPayment)
            }
            registrationPayments={registrationPaymentsQuery?.data}
          />
        </ModalXXL>

        {/* Modal matriculas create*/}
        <Formik
          enableReinitialize
          validationSchema={createRegistrationPaymentValidationSchema}
          initialValues={
            currentRegistrationPaymentEdit ??
            createRegistrationPaymentInitialValues
          }
          onSubmit={(values, formikHelpers) => {
            if (currentRegistrationPaymentEdit) {
              updateRegistrationPayment({
                ...values,
                branchId: id,
                id: currentRegistrationPaymentEdit?.id,
              });
            } else {
              createRegistrationPayment({ ...values, branchId: id });
            }
            setCurrentRegistrationPaymentEdit(undefined);
            openModalCreateMatriculas();
            formikHelpers.resetForm();
          }}
        >
          {({ handleChange, values, errors, handleSubmit, resetForm }) => (
            <Modal
              open={openModalCreateMatriculasState}
              Close={openModalCreateMatriculas}
              tittleModal={t("customer-to-gym-subscription.views.registration")}
              onClickCreate={handleSubmit}
              onClose={() => {
                setCurrentRegistrationPaymentEdit(undefined);
                openModalCreateMatriculas();
                resetForm();
              }}
              textButtonCreate={t("general.create")}
              textButtonClose={t("general.cancel")}
            >
              <div className="col-span-full mt-5">
                <InputWithCornerHint
                  label={t("customer-to-gym-subscription.views.name")}
                  span={t("general.mandatory")}
                  name="name"
                  type="text"
                  placeholder={t("customer-to-gym-subscription.views.name")}
                  onChange={handleChange}
                  error={!!errors.name}
                  textError={errors.name}
                  value={values.name}
                />
              </div>
              <div className="col-span-full mt-5">
                <InputDropDownSpan
                  label={t("customer-to-gym-subscription.views.mount")}
                  span={t("general.mandatory")}
                  id=""
                  name="price"
                  type="number"
                  value={values.price}
                  selectValue={values.currency}
                  onSelectChange={handleChange}
                  onChange={handleChange}
                  placeholder={t("customer-to-gym-subscription.views.mount")}
                  idSelect=""
                  labelSelect=""
                  error={!!errors.currency}
                  textError={errors.currency}
                  nameSelect="currency"
                  options={currencies.map((item) => ({
                    ...item,
                    id: item.currency,
                    text: item.currency,
                  }))}
                />
              </div>
            </Modal>
          )}
        </Formik>

        {/* Modal matriculas Pause*/}
        <Formik
          enableReinitialize
          validationSchema={disabledFeeValidationSchema}
          initialValues={initialValues}
          onSubmit={(values, formikHelpers) => {}}
        >
          {({
            handleChange,
            values,
            errors,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <Modal
              open={openModalPause}
              Close={openModalPauseState}
              tittleModal={t("customer-to-gym-subscription.views.pause")}
              textButtonCreate={t("general.accept")}
              textButtonClose={t("general.cancel")}
              onClickCreate={async () => {
                try {
                  await disableFeeBranch({
                    ...values,
                    branchId: id,
                  }).unwrap();
                  openModalPauseState();
                  handleSubmit();
                  resetForm();
                  getterFees({ branchId: id, search: debouncedSearch });

                  toasts.success(
                    "Modificación exitosa",
                    "La cuota se ha modificado correctamente"
                  );
                } catch (error) {
                  toasts.danger(
                    "Error al pausar la cuota",
                    "Ha ocurrido un error al pausar la cuota"
                  );
                  console.error(error);
                }
              }}
            >
              <p className="text-sm text-gray-900 mt-5">
                {t("customer-to-gym-subscription.views.pause_description1")}
              </p>
              <p className="text-sm text-red-500 mt-5">
                {t("customer-to-gym-subscription.views.pause_description2")}
              </p>
              <div className="col-span-full mt-5 mb-10">
                <DateRangePicker
                  id="date"
                  label={t("customer-to-gym-subscription.views.interval_date")}
                  onDateChange={(startDate, endDate) => {
                    setFieldValue("dateInitial", startDate);
                    setFieldValue("dateEnd", endDate);
                  }}
                  value={{
                    startDate: values.dateInitial
                      ? new Date(values.dateInitial)
                      : new Date(),
                    endDate: values.dateEnd
                      ? new Date(values.dateEnd)
                      : new Date(),
                  }}
                />
              </div>
            </Modal>
          )}
        </Formik>

        {/* Modal MOTIVOS TABS*/}
        <ModalWithTabs
          open={openModalMotivos}
          Close={openModalMotivosState}
          textButtonClose={t("general.close")}
          functionButtonTopCreate={openModalCreateMotivos}
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          modalClassName="z-50"
        >
          <div className="mt-6">
            {selectedTab === 1 && (
              <div>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                  <div className="pb-4">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {t("customer-to-gym-subscription.views.motive_down")}
                    </h3>
                    {reasonsQuery?.data
                      ?.filter(({ type }: any) => type == 1)
                      .map((reason: any) => (
                        <ul className="space-y-2 mt-4 text-sm text-gray-500">
                          <li>{reason.description}</li>
                        </ul>
                      ))}
                  </div>

                  <div className="pb-4">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {t("customer-to-gym-subscription.views.motive_up")}
                    </h3>
                    {reasonsQuery?.data
                      ?.filter(({ type }: any) => type == 2)
                      .map((reason: any) => (
                        <ul className="space-y-2 mt-4 text-sm text-gray-500">
                          <li>{reason.description}</li>
                        </ul>
                      ))}
                  </div>
                </div>
              </div>
            )}
            {selectedTab === 2 && (
              <>
                <DateRangePicker
                  id="agreements-date"
                  label={t("lesson.views.interval_date")}
                  value={{
                    startDate: agreementsFormik.values.startDate
                      ? DateTime.fromFormat(
                          agreementsFormik.values.startDate,
                          "yyyy-MM-dd"
                        ).toJSDate()
                      : new Date(),
                    endDate: agreementsFormik.values.endDate
                      ? DateTime.fromFormat(
                          agreementsFormik.values.endDate,
                          "yyyy-MM-dd"
                        ).toJSDate()
                      : new Date(),
                  }}
                  onDateChange={(startDate, endDate) => {
                    setIsLoading(true);
                    agreementsFormik.setFieldValue(
                      "startDate",
                      DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")
                    );
                    agreementsFormik.setFieldValue(
                      "endDate",
                      DateTime.fromJSDate(endDate).toFormat("yyyy-MM-dd")
                    );
                  }}
                />

                <div className="mt-10">
                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div className="border-b border-gray-200 pb-4">
                      <h3 className="text-lg font-semibold text-gray-800">
                        {t("customer-to-gym-subscription.views.motive_down")}
                      </h3>
                      <div className="mt-4 bg-gray-100 p-4 rounded-lg">
                        {isLoading && (
                          <div className="flex justify-center items-center h-90 mt-20">
                            <FontAwesomeIcon
                              icon={faLoader}
                              spin
                              className="text-6xl"
                            />
                          </div>
                        )}
                        <div
                          id="reason_high"
                          style={{ width: "100%", height: "400px" }}
                        ></div>
                      </div>
                    </div>

                    <div className="border-b border-gray-200 pb-4">
                      <h3 className="text-lg font-semibold text-gray-800">
                        {t("customer-to-gym-subscription.views.motive_up")}
                      </h3>
                      <div className="mt-4 bg-gray-100 p-4 rounded-lg">
                        {isLoading && (
                          <div className="flex justify-center items-center h-90 mt-20">
                            <FontAwesomeIcon
                              icon={faLoader}
                              spin
                              className="text-6xl"
                            />
                          </div>
                        )}
                        <div
                          id="reasons_low"
                          style={{ width: "100%", height: "400px" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </ModalWithTabs>

        {/* Modal MOTIVOS TABS*/}
        <Formik
          initialValues={createReasonInitialValue}
          validationSchema={createReasonValidationSchema}
          onSubmit={async (values: CreateReasonValues, formikHelpers) => {
            try {
              await createReason({ ...values, branchId: id }).unwrap();
              openModalCreateMotivos();
              toasts.success(
                "Registro exitoso",
                "El motivo se ha registrado correctamente"
              );
            } catch (error) {
              toasts.danger(
                "Error al registrar",
                "Ha ocurrido un error al registrar el motivo"
              );
            } finally {
              setIsLoading(false);
              formikHelpers.resetForm();
            }
          }}
        >
          {({ handleChange, values, errors, setFieldValue, handleSubmit }) => (
            <Modal
              open={openModalCreateMotivosState}
              Close={openModalCreateMotivos}
              textButtonCreate={t("general.accept")}
              textButtonClose={t("general.cancel")}
              onClickCreate={handleSubmit}
              tittleModal={t(
                "customer-to-gym-subscription.views.create_reason"
              )}
            >
              <div className="col-span-full mt-5">
                <InputWithCornerHint
                  label={t("customer-to-gym-subscription.views.motive")}
                  name="description"
                  type="text"
                  placeholder={t("customer-to-gym-subscription.views.motive")}
                  onChange={handleChange}
                  error={!!errors.description}
                  value={values.description}
                />
              </div>
              <div className="col-span-full mt-5">
                <Select
                  name="type"
                  selected={reasonTypes?.find(
                    (reasonType) => reasonType.value == values.type
                  )}
                  setSelected={(option: any) =>
                    setFieldValue("type", option?.value)
                  }
                  options={Array.isArray(reasonTypes) ? reasonTypes : []} // Verificación para asegurar que options sea un array
                  tittle={t(
                    "customer-to-gym-subscription.views.description_reason"
                  )}
                />
              </div>
            </Modal>
          )}
        </Formik>
      </div>
    </div>
  );
};
